export default {
      id: "i-pyramid-usage",
      viewBox: "0 0 51 51",
      url: __webpack_public_path__ + "img/sprite.svg#i-pyramid",
      toString: function () {
        return this.url;
      }
    }